import React from 'react';
import './QuiSommesNous.css';
import { FaLightbulb, FaUsers, FaHandshake } from 'react-icons/fa';
import etudiantImage from '../../../assets/images/8642448_3967400.jpg'; 
const QuiSommesNous = () => {
  return (
    <section className="qui-sommes-nous-sectionassociation" id="qui-sommes-nous">
      <div className="section-backgroundassociation">
        <div className="background-glowassociation"></div>
        <div className="background-shapesassociation">
          <div className="shape-circleassociation"></div>
          <div className="shape-triangleassociation"></div>
          <div className="shape-hexagonassociation"></div>
        </div>
      </div>
      
      <div className="qui-sommes-nous-containerassociation">
        <div className="section-headerassociation">
          <h2 className="section-titleassociation">
            <span className="title-textassociation">QUI SOMMES-NOUS ?</span>
            <span className="title-underlineassociation"></span>
          </h2>
          <div className="section-subtitleassociation">
            L'ÉTUDIANT ÉTRANGER – ETEF : Votre partenaire de confiance
          </div>
        </div>
        
        <div className="content-wrapper">
          <div className="text-content">
            <div className="intro-text">
              <p className="lead">
                L'association <span className="highlight">L'ÉTUDIANT ÉTRANGER – ETEF</span> est née d'un constat simple : 
                venir étudier en France est une aventure pleine de promesses, mais aussi de défis.
              </p>
              
              <p>
                Nous accompagnons les étudiants étrangers dans leur parcours académique en France 
                jusqu'à leur insertion dans la vie professionnelle.
              </p>
            </div>
            
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-icon">
                  <FaLightbulb />
                </div>
                <div className="timeline-content">
                  <h3>Notre origine</h3>
                  <p>
                    Nous avons créé l'entreprise ETEF en 2018 afin d'accompagner les étudiants 
                    étrangers qui souhaitent poursuivre leurs études supérieures en France.
                  </p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="timeline-icon">
                  <FaUsers />
                </div>
                <div className="timeline-content">
                  <h3>Notre évolution</h3>
                  <p>
                    En 2025, nous créons l'association l'ÉTUDIANT ETRANGER - ETEF, dans le but 
                    de répondre à un besoin identifié et précis que nous avons analysé au cours 
                    de ces dernières années.
                  </p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="timeline-icon">
                  <FaHandshake />
                </div>
                <div className="timeline-content">
                  <h3>Notre objectif</h3>
                  <p>
                    Nous souhaitons faciliter l'intégration des étudiants étrangers et leur 
                    fournir les ressources nécessaires pour réussir leurs études et leur vie en France.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="image-content">
            <div className="image-container">
              <div className="image-frame">
             <img 
      src={etudiantImage} 
      alt="Étudiants internationaux en France"
      className="qui-sommes-image"
    />
                <div className="image-overlay"></div>
              </div>
              
              <div className="image-stats">
                <div className="stat-card">
                  <div className="stat-number">7+</div>
                  <div className="stat-label">Années d'expérience</div>
                </div>
                <div className="stat-card">
                  <div className="stat-number">60+</div>
                  <div className="stat-label">Partenariats</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuiSommesNous;